<div class="input-group input-group-sm">
  <input [id]="input.MainElementList[0].ID" [attr.type]="input.MainElementList[0].Type" class="form-control q-bo-input q-bo-wrap" aria-label="Small" aria-describedby="inputGroupEmail"
         [disabled]="input.MainElementList[0].Disabled"
         [(ngModel)]="input.MainElementList[0].Value"
         [ngClass]="setClass(input)">
  
  <div *ngFor="let button of input?.MainElementList?.slice(1)" class="input-group-append">
    <button *ngIf="button.Type === 'BUTTON'"
            class="q-btn q-bo q-main p-0"
            (click)="OnButtonClicked(button, ModalBoEmail);"
            [id]="button?.ID ? button?.ID : ''"
            [title]="button?.Tooltip ? button?.Tooltip : ''">
      <i class="{{button.Src}}"></i>
    </button>
  </div>
</div>

<ng-template #ModalBoEmail let-modalBoEmail>
  <div #header class="modal-header w-100">
    <h5 class="modal-title big-title" id="exampleModalLongTitle">Historique des campagnes</h5>

    <button type="button" class="close" aria-label="Close" (click)="modalBoEmail.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body overflow-auto" [style.height]="sanitizer.bypassSecurityTrustStyle('calc(80vh - ' + header.offsetHeight + 'px)')">
    <div *ngIf="!modalLoading" class="row">
      <q-customgrid class='h-100 w-100'
                    [customgridParam]="customgridParam"
                    [customgridHeight]="'calc(80vh - ' + header.offsetHeight + 'px)'"
                    #agGrid>
      </q-customgrid>
    </div>
    <div *ngIf="modalLoading" class="row q-c-main my-2 justify-content-center">
      <i class="fas fa-spin fa-spinner fa-pulse fa-5x"></i>
    </div>
  </div>
</ng-template>
